/**
 * Configuração dos filtros para a listagem de viagens
 */
export const filterConfig = [
  {
    id: 'NomeMotorista',
    type: 'text',
    label: 'Nome do Motorista',
    placeholder: 'Digite o nome do motorista'
  },
  {
    id: 'NumeroPlaca',
    type: 'text',
    label: 'Placa do Veículo',
    placeholder: 'Digite a placa (ex: ABC1234)'
  },
  {
    id: 'NumeroFrota',
    type: 'text',
    label: 'Número da Frota',
    placeholder: 'Digite o número da frota'
  },
  {
    id: 'NumeroCarga',
    type: 'text',
    label: 'Número da Carga',
    placeholder: 'Digite o número da carga'
  },
  {
    id: 'CidadeOrigem',
    type: 'text',
    label: 'Cidade de Origem',
    placeholder: 'Digite a cidade de origem'
  },
  {
    id: 'CidadeDestino',
    type: 'text',
    label: 'Cidade de Destino',
    placeholder: 'Digite a cidade de destino'
  },
  {
    id: 'DataInicio',
    type: 'date',
    label: 'Data de Início (a partir de)',
    placeholder: 'Selecione a data'
  },
  {
    id: 'DataFim',
    type: 'date',
    label: 'Data de Fim (até)',
    placeholder: 'Selecione a data'
  }
];
